export default __webpack_public_path__ + "static/media/Group2131-yono.394c3fc0.png";